module.exports = __webpack_public_path__ + "img/theta.a505f47e.svg";